import { Injectable, InjectionToken, ViewContainerRef } from '@angular/core';

import { IResourceContext } from '../resource-context.typings';

/**
 * A service to manage AppContextModule instances provision and inject the correct AppContextComponent view
 */
@Injectable({
    providedIn: 'root'
})
export abstract class BaseAppModuleManagementService {
    public abstract ensureResourceContextModule(contextData: IResourceContext): Promise<void>;
    public abstract setMainViewContainerRef(viewRef: ViewContainerRef): void;
    public abstract activateContextModule(contextData: IResourceContext): void;
    public abstract getModuleActivatedPromise(contextData: IResourceContext): Promise<unknown>;
    public abstract getScopedService<T>(contextData: IResourceContext, serviceName: string | InjectionToken<T>): Promise<T>;
    public abstract getCachedScopedServiceSync<T>(contextData: IResourceContext, serviceName: string | InjectionToken<T>): T | undefined;
}
